import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

/* global window */

// eslint-disable-next-line
import OT from 'opentok';

import CopyPreToClipboard from './CopyPreToClipboard';
import PdfExportButton from './PdfExportButton';
import CopyToClipboard from 'react-copy-to-clipboard';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const messages = defineMessages({
  START_CONVERSATION: {
    id: 'CallControl.START_CONVERSATION',
    defaultMessage: 'Gespräch anfangen',
  },
  GUEST_COPIED: {
    id: 'CallControl.GUEST_COPIED',
    defaultMessage: 'Gast-Link in Zwischenablage kopiert!',
  },
  INVITE_GUEST: {
    id: 'CallControl.INVITE_GUEST',
    defaultMessage: 'Gast einladen',
  },
});

function CallControl(props) {
  const {
    activeCallCreatedAndRunning,
    call,
    customer,
    customerSlug,
    handleStopCall,
    handleCreateSMS,
    openCallBeginModal,
    selectedOrderId,
    company,
    intl: { formatMessage },
  } = props;

  let customPages = '';
  if (company.hasCustomPages) {
    customPages = `/custom/${company.id}`;
  }

  const callUrl = `${window.location.origin}${customPages}/v/${customerSlug}/`;
  if (activeCallCreatedAndRunning && !call.call_end) {
    return (
      <div className="video-chat-header-right-col flex-end">
        {call && !call.call_end && (
          <button
            style={{ marginLeft: 15 }}
            className="lh-btn lh-btn-warning lh-btn-small"
            onClick={() => handleStopCall()}
          >
            <i className="icon-phone-down" style={{ fontSize: 15 }} />
          </button>
        )}
        { customer.phone &&
          <button
            style={{ marginLeft: 15 }}
            className="lh-btn lh-btn-default lh-btn-small"
            onClick={() => handleCreateSMS()}
          >
            <i className="fa fa-envelope-o" /> SMS
          </button>
        }

        {company && company.active_subscription && company.active_subscription.product && company.active_subscription.product.feature_conference === true && (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="guest-copy">{formatMessage(messages.GUEST_COPIED)}</Tooltip>}
            trigger="click"
            rootClose
          >
            <CopyToClipboard text={`${window.location.origin}${customPages}/g/${customerSlug}`}>
              <button
                style={{ marginLeft: 15 }}
                className="lh-btn lh-btn-default lh-btn-small"
              >
                <i className="fa fa-user-plus" /> {formatMessage(messages.INVITE_GUEST)}
              </button>
            </CopyToClipboard>
          </OverlayTrigger>
        )}

        <CopyPreToClipboard content={callUrl} />
        <PdfExportButton customer={customer} selectedOrderId={selectedOrderId} />
      </div>
    );
  }
  if (OT.checkSystemRequirements() === 0) {
    return <div />;
  }
  return (
    <div className="video-chat-header-right-col flex-end">
      <button
        className="lh-btn lh-btn-primary start-call"
        onClick={openCallBeginModal}
        style={{ height: '38px', boxSizing: 'border-box' }}
      >
        {formatMessage(messages.START_CONVERSATION)}
      </button>
      <PdfExportButton customer={customer} selectedOrderId={selectedOrderId} />
    </div>
  );
}

export default injectIntl(CallControl);
